// Transaction Reference Types (matches backend Transaction_Types enum)
export const TRANSACTION_REFERENCE = [
 
  { value: 'ACCOUNT_PAYABLE', label: 'Account Payable' },
  { value: 'REIMBURSEMENTS', label: 'Reimbursements' },
  
];
